import { put, call } from 'redux-saga/effects';
import { END_POINTS } from '../../api/endpoints';
import { API } from '../../api/api';
import { createAppointmentSuccessAction ,createAppointmentFailureAction } from '../actions/appointmentActions';

// ------ create appointment for patient ------

export function* createAppointment(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const appointmentResponse = yield call(
            API.post,
            `${baseUrl}${END_POINTS.createAppointment}`,
            {
                ...action.payload
            }
        );

        if (!appointmentResponse.success) {
            throw new Error(appointmentResponse.message)
        }
        yield put(createAppointmentSuccessAction(appointmentResponse.data));
    } catch (error) {
        yield put(createAppointmentFailureAction(error.message));
    }
}
